import { useEffect, useMemo, useState } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import configureAppStore from "./store/ConfigureStore";
import { App } from "./App";
import "./index.css";
import theme from "./styles/mui/theme";
import { GetEnvVariables } from "./utils";
import { IS_LOCALHOST, updateVariables } from "./constants/Config";
import { loadInsights } from "./utils/logHandlers/appInsight";

const store = configureAppStore();
const container = document.getElementById("root")!;
const root = createRoot(container);

const AppWithOutAuthentication = () => {
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);

  const variables = useMemo<Record<string, any>>(() => {
    const envVariables = {
      REACT_APP_REFERRAL_REQUEST_REPLACE_START: "[_APP_REPLACE_START_]",
      REACT_APP_REFERRAL_REQUEST_HOST_CONFIG_URL_RR: "[_APP_HOST_CONFIG_URL_RR_]",
      REACT_APP_REFERRAL_REQUEST_HOST_CONFIG_URL_CHECK_ELIGIBILITY:
        "[_APP_HOST_CONFIG_URL_CHECK_ELIGIBILITY_]",
      REACT_APP_REFERRAL_REQUEST_APPINSIGHTS_CONNECTION_STRING:
        "[_APP_APPINSIGHTS_CONNECTION_STRING_]",
      REACT_APP_REFERRAL_REQUEST_GOOGLE_MAP_API_URL: "[_APP_GOOGLE_MAP_API_URL_]",
      REACT_APP_REFERRAL_REQUEST_GOOGLE_MAP_KEY: "[_APP_GOOGLE_MAP_KEY_]",
      REACT_APP_REFERRAL_REQUEST_DEBUG: "[_APP_DEBUG_]",
      REACT_APP_REFERRAL_REQUEST_DOCUMENT_MAX_SIZE: "[_APP_DOCUMENT_MAX_SIZE_]",
      REACT_APP_REFERRAL_REQUEST_DOCUMENT_MIN_SIZE: "[_APP_DOCUMENT_MIN_SIZE_]",
      REACT_APP_REFERRAL_REQUEST_FAX_MAX_SIZE: "[_APP_FAX_MAX_SIZE_]",
      REACT_APP_REFERRAL_REQUEST_IS_PRODUCTION_ENV: "[_APP_IS_PRODUCTION_ENV_]",
      REACT_APP_REFERRAL_REQUEST_PROVIDER_RELATION_EMAIL:
        "[_APP_PROVIDER_RELATION_EMAIL_]",
      REACT_APP_REFERRAL_REQUEST_PROVIDER_PORTAL_URL:
        "[_APP_PROVIDER_PORTAL_URL_]",
      REACT_APP_REFERRAL_REQUEST_PRIVACY_PRACTICE_URL:
        "[_APP_PRIVACY_PRACTICE_URL_]",
      REACT_APP_REFERRAL_REQUEST_REPLACE_END: "[_APP_REPLACE_END_]",
    };

    return IS_LOCALHOST
      ? (GetEnvVariables() as unknown as Record<string, any>)
      : envVariables;
  }, []);

  useEffect(() => {
    updateVariables(variables);
    loadInsights(
      variables.REACT_APP_REFERRAL_REQUEST_APPINSIGHTS_CONNECTION_STRING,
    );
    setIsConfigLoaded(true);
  }, [variables]);

  return (
    <div>
      {isConfigLoaded ? (
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </Provider>
      ) : (
        <>Loading...</>
      )}
    </div>
  );
};

root.render(<AppWithOutAuthentication />);
